module.exports = __webpack_public_path__ + "img/singlecourse.872211b6.jpg";